<template>
    <div class="w-full px-4 py-5 border border-customSoftGray rounded-lg shadow-lg mb-6">
         <div class="flex justify-between items-center mt-2">
             <div class="flex items-center">
                 <FacebookIcon class="h-12 mr-2" />
                 <div>
                    <InfoPopUp class="mt-6" v-show="showInfo" information="Updating your Facebook connections will add any new Groups or Pages to your account" />
                    <div @click="showInfo = true" @mouseleave="showInfo = false" class="flex items-center">
                        <h2 class="mr-2 font-bold">Facebook Account</h2>
                        <InfoIcon class="cursor-pointer"/>  
                    </div>
                    <span v-if="account.length === 0"  class="font-light text-sm  text-cosmosFire">No account connected</span>
                    <span v-else  class="font-light text-sm  text-cosmosFire">{{ accountName }}</span>
                 </div>
             </div>
             <div class=" flex items-center">
                <button v-if="account.length === 0" @click="$emit('link')" class="flex bg-aquamarine text-white rounded-lg px-6 py-3 mr-2">
                    <span class="text-sm">Link Account</span>
                </button>
                <button v-else @click="$emit('update')" class=" bg-aquamarine text-white rounded-lg px-6 py-3 mr-2 hidden md:block">
                    <span class="text-sm">Update Connections</span>
                </button>
                <button v-if="account.length > 0" class="border border-gray p-2 rounded-lg" @click="$emit('remove')">
                    <TrashIcon/>
                </button>
                
            </div>
         </div>
         <div class="flex justify-center items-center mt-5">
            <button v-if="account.length !== 0" @click="$emit('update')" class="w-full bg-aquamarine text-white rounded-lg px-6 py-3 mt-2 mr-2 md:hidden">
                <span class="text-sm">Update Connections</span>
            </button>
        </div>
    </div>
</template>

<script>
import FacebookIcon from '@/components/svg/FacebookIcon'
import TrashIcon from '@/components/svg/TrashIcon';
import InfoIcon from '@/components/svg/InfoIcon';
import InfoPopUp from '@/components/settings/social/partials/ConnectedRow/partials/InfoPopUp';
export default {
    name:"ConnectionRow",

    data() {
        return {
            showInfo: false
        }
    },

    props: {
        account: {
            type: Array,
            require:true 
        },
    },

    components: {
        FacebookIcon,
        TrashIcon,
        InfoIcon,
        InfoPopUp
    },

    computed: {
        accountName: function() {
            return this.account[0].metadata ? JSON.parse(this.account[0].metadata).name : '';
        },
    }
}
</script>